import React, { useContext } from 'react'
import SilageStepLayout from '../../SilageStepLayout'
import { StyledGroup } from '../../GrassSilageStep/style'
import OrganicFertilizers from '../../GrassSilageStep/SecondStep/OrganicFertilizers'
import MineralFertilizers from '../../GrassSilageStep/SecondStep/MineralFertilizers'
import { ClimaOptionsContext } from '..'

const SecondGrassStep: React.FC = () => {
  const options = useContext(ClimaOptionsContext)

  return (
    <SilageStepLayout
      infoText={`Wählen Sie <strong>alle ausgebrachten Düngemittel</strong> für die Maissilage-Anbauflächen aus (erneuter Klick entfernt die Auswahl). 
        Tragen Sie anschließend für jedes Düngemittel die <strong>Ausbringmenge</strong> und die <strong>Ausbringtechnik</strong> ein, wobei Sie auf die korrekten 
        <strong>Einheiten</strong> achten müssen. 
        Diese Angaben sind für die Berechnung der <strong>Treibhausgasemissionen</strong> der 
        Düngung (Lachgas aus N-Düngung, CO<sub>2</sub> aus Carbonat/Harnstoff und Emissionen aus der Herstellung mineralischer Düngemittel) notwendig.`}
    >
      <StyledGroup style={{ display: 'block', minHeight: 200 }}>
        <MineralFertilizers options={options} mineralKey='maizeSilage.mineralFertilizers' />
      </StyledGroup>
      <StyledGroup style={{ display: 'block', minHeight: 200 }}>
        <OrganicFertilizers options={options} organicKey='maizeSilage.organicFertilizers' />
      </StyledGroup>
    </SilageStepLayout>
  )
}

export default SecondGrassStep